import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import LegalLangToggle from './LegalLangToggle';
import '../../pages/CSS/legal.css';

/**
 * Profile-style layout for Privacy, About, How it works, Report / Suggestion.
 */
const LegalPageLayout = ({
  icon: PageIcon,
  title,
  subtitle,
  subtitleVariant = 'subtitle',
  backLabel,
  children,
}) => {
  const subtitleClass =
    subtitleVariant === 'effective' ? 'legal-effective' : 'legal-subtitle';

  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-top-bar">
          <Link to="/" className="legal-back-btn">
            <ArrowLeft size={20} />
            {backLabel}
          </Link>
          <LegalLangToggle />
        </div>

        <header className="legal-page-header">
          <div className="legal-title-block">
            <div className="legal-title-icon" aria-hidden>
              <PageIcon size={28} />
            </div>
            <div>
              <h1 className="page-title">{title}</h1>
              {subtitle ? <p className={subtitleClass}>{subtitle}</p> : null}
            </div>
          </div>
        </header>

        <div className="legal-content">{children}</div>
      </div>
    </div>
  );
};

export default LegalPageLayout;
